module.exports = "/dist/assets/images/pause-icon.svg";